module.exports = __webpack_public_path__ + "img/global.1df916cf.svg";